var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHowToGuide = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 0C3.52065 0 2.82118 0.289731 2.30546 0.805456C1.78973 1.32118 1.5 2.02065 1.5 2.75V21.25C1.5 21.9793 1.78973 22.6788 2.30546 23.1945C2.82118 23.7103 3.52065 24 4.25 24H18.25C18.9793 24 19.6788 23.7103 20.1945 23.1945C20.7103 22.6788 21 21.9793 21 21.25V5.25C21 5.05109 20.921 4.86032 20.7803 4.71967L16.2803 0.21967C16.1397 0.0790176 15.9489 0 15.75 0H4.25ZM3.36612 1.86612C3.60054 1.6317 3.91848 1.5 4.25 1.5H15V5.24998C15 5.66419 15.3358 5.99998 15.75 5.99998H19.5V21.25C19.5 21.5815 19.3683 21.8994 19.1339 22.1339C18.8995 22.3683 18.5815 22.5 18.25 22.5H4.25C3.91848 22.5 3.60054 22.3683 3.36612 22.1339C3.1317 21.8994 3 21.5815 3 21.25V2.75C3 2.41848 3.1317 2.10054 3.36612 1.86612ZM18.4393 4.49998L16.5 2.56066V4.49998H18.4393Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.49 18.75C10.49 18.3358 10.8258 18 11.24 18H11.25C11.6642 18 12 18.3358 12 18.75C12 19.1642 11.6642 19.5 11.25 19.5H11.24C10.8258 19.5 10.49 19.1642 10.49 18.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 9C10.0074 9 9 10.0074 9 11.25C9 11.6642 8.66421 12 8.25 12C7.83579 12 7.5 11.6642 7.5 11.25C7.5 9.17893 9.17893 7.5 11.25 7.5C13.3211 7.5 15 9.17893 15 11.25C15 13.0018 13.7995 14.4713 12.1774 14.8842C12.107 14.9022 12.0513 14.9386 12.0207 14.9716C12.0068 14.9866 12.0017 14.9969 12.0003 15.0001C12.0002 15.0004 12.0001 15.0007 12 15.0009V15.75C12 16.1642 11.6642 16.5 11.25 16.5C10.8358 16.5 10.5 16.1642 10.5 15.75V15C10.5 14.1392 11.1859 13.5888 11.8074 13.4306C12.7808 13.1828 13.5 12.2994 13.5 11.25C13.5 10.0074 12.4926 9 11.25 9Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHowToGuide);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/how-to-guide.42745604f505f954eb104f4ad2bc2b43.svg";